import { Drawable, Point, Rect, CanvasEffect, GraphObject, Spinwise, Collidable } from 'reactive-graphics';

export class Star implements Drawable, Spinwise {
 
  public dir = 1;
  public spin = 0;
  public elasticity = 1;
  protected outline = false;
 
  constructor(public radius: number, private points: number, public position: Point, public color = "white") {}

  protected currentStyle() {
    return this.color;
  }

  draw(context: CanvasRenderingContext2D) {
    context.beginPath();
    if (this.outline) {
      context.strokeStyle = this.currentStyle();
    } else {
      context.fillStyle = this.currentStyle();
    }
    context.lineWidth = 3;
    let grad = 0;
    const delta = 4 * Math.PI / this.points;
    const { spin } = this;
    const radius = this.radius * this.elasticity;
    context.moveTo(this.position.x + radius * Math.sin(grad + spin), this.position.y - radius * Math.cos(grad + spin));
    while (grad < 4 * Math.PI) {
      context.lineTo(this.position.x + radius * Math.sin(grad + spin + delta), this.position.y - radius * Math.cos(grad + spin + delta));
      grad += delta;
    }
    if (this.outline) {
      context.stroke();
    } else {
      context.fill();
    }
  }
}

export class StarObject extends Star implements GraphObject, Collidable {

  private _collision = false;

  public get collision() {
    return this._collision;
  }

  public set collision(coll: boolean) {
    this._collision = this.outline = coll;
  }

  protected currentStyle() {
    return this.collision? "red" : super.currentStyle();
  }

  draw(context: CanvasRenderingContext2D) {
    //context.setLineDash([10, 5]);
    super.draw(context);
    this.collision = false;
  }

  /* Minimum Bounding Rect */
  getBoundingRect(): Rect {
    const radius = this.radius * this.elasticity;
    const min = {x: this.position.x - radius, y: this.position.y - radius};
    const max = {x: this.position.x + radius, y: this.position.y + radius};
    return new Rect(min, max);
  }

  getBoundaries(): Rect[] {
    //return [this.getBoundingRect()];
    const radius = this.radius * this.elasticity;
    const shortRadius = this.radius * this.elasticity / 2;
    // const shortMin = {x: this.position.x - shortRadius, y: this.position.y - shortRadius};
    // const shortMax = {x: this.position.x + shortRadius, y: this.position.y + shortRadius};
    const vertMin = {x: this.position.x - shortRadius, y: this.position.y - radius};
    const vertMax = {x: this.position.x + shortRadius, y: this.position.y + radius};
    const horiMin = {x: this.position.x - radius, y: this.position.y - shortRadius};
    const horiMax = {x: this.position.x + radius, y: this.position.y + shortRadius};
    return [new Rect(vertMin, vertMax), new Rect(horiMin, horiMax)];
  }
}
